import { Component } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";
import { Router } from "@angular/router";

@Component({
  selector: "app-freemium-plan-dialog",
  templateUrl: "./freemium-plan-dialog.component.html",
  styleUrls: ["./freemium-plan-dialog.component.scss"],
  standalone: false,
})
export class FreemiumPlanDialogComponent {
  constructor(
    private dialogRef: MatDialogRef<FreemiumPlanDialogComponent>,
    private router: Router,
  ) {}

  goToSubscription(): void {
    this.dialogRef.close();
    void this.router.navigate(["/subscription"]);
  }

  close(): void {
    this.dialogRef.close();
  }
}
